import styled from 'styled-components';

export const ContentSection = styled.div<{
  bgColor?: string;
  horizontalAlign?: string;
  verticalAlign?: string;
  margin?: string;
  padding?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  max-width: 794px;
  margin: auto;
  padding: 16px;
  padding-bottom: 150px;
  ${(props) =>
    props.bgColor &&
    `
  background-color: ${props.bgColor};
`};
  ${(props) =>
    props.horizontalAlign &&
    `
  align-items: ${props.horizontalAlign};
`};
  ${(props) =>
    props.verticalAlign &&
    `
  justify-items: ${props.verticalAlign};
`};
  ${(props) =>
    props.margin &&
    `
  margin: ${props.margin};
`};
  ${(props) =>
    props.padding &&
    `
  padding: ${props.padding};
`};
`;
